import { styles } from "./ImageContent.style";
import { Image } from "../../../../elements/Image";

export interface IImageContentProps {
  image: {
    url: string;
    width?: number;
    height?: number;
    title?: string;
  };
  mobileImage?: {
    url: string;
    width?: number;
    height?: number;
    title?: string;
  };
  isSampleReportStyle: boolean;
  fetchPriorityHigh?: boolean;
}

export function ImageContent({ image, mobileImage, isSampleReportStyle, fetchPriorityHigh }: IImageContentProps) {
  return (
    <div className={styles.imageWrapper()}>
      {isSampleReportStyle ? (
        <>
          {mobileImage && (
            <div className={styles.imageMobile()}>
              <Image image={mobileImage} fetchPriorityHigh={fetchPriorityHigh} loadEagerly={fetchPriorityHigh} />
            </div>
          )}
          <div className={styles.imageDesktop()}>
            <Image image={image} fetchPriorityHigh={fetchPriorityHigh} loadEagerly={fetchPriorityHigh} />
          </div>
        </>
      ) : (
        <Image image={image} fetchPriorityHigh={fetchPriorityHigh} loadEagerly={fetchPriorityHigh} />
      )}
    </div>
  );
}
